import { render, staticRenderFns } from "./ItemInfoModal.vue?vue&type=template&id=471573ad&scoped=true&"
import script from "./ItemInfoModal.vue?vue&type=script&lang=js&"
export * from "./ItemInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemInfoModal.vue?vue&type=style&index=0&id=471573ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471573ad",
  null
  
)

export default component.exports